import { Table } from '@octano/global-ui';
import { SectionTitle } from '../../../../components/text';
import { PaymentInfo } from '../../types';
import { useColumns } from './hooks/useColumns';

type Props = {
  data: PaymentInfo;
  texts: {
    title: string;
    table: {
      noResults: string;
      headers: {
        concept: string;
        amount: string;
        paymentDate: string;
        status: string;
        action: string;
      };
      values: {
        concept: string;
        button: string;
        payment: {
          pending: string;
          paid: string;
        };
      };
    };
  };
};

export function PaymentStatus({ data, texts }: Props) {
  const columns = useColumns(texts.table);
  const tableData = data ? [data] : [];
  return (
    <>
      <SectionTitle text={texts.title} />
      <Table
        columns={columns}
        data={tableData}
        noResultsText={texts.table.noResults}
      />
    </>
  );
}
